export default {
      id: "icon-allyear-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-allyear",
      toString: function () {
        return this.url;
      }
    }